import axios from "axios";

const WITHDRAW_API_BASE =
  process.env.VUE_APP_UFA_API_BASE || "https://ufaeasy.apifast.xyz";

export interface CustomerTurnoverDetails {
  mode: string;
  depositAndBonus: number;
  specialPromotion: number;
  specialPromotionActivated: number;
  eligibleCredit: number;
  turnoverNumerator: number;
  turnoverDenominator: number;
  required: number;
  validAmt: number;
  remaining: number;
  passed: boolean;
  balance: number;
  withdrawableAmount: number;
  checkedAt: number;
  checkedAtText: string;
}

export interface CustomerWithdrawalResponse {
  status: boolean;
  created: boolean;
  duplicate: boolean;
  historyId: string;
  withdrawAmount: number;
  withdrawableAmount: number;
  turnover: CustomerTurnoverDetails | null;
}

export class CustomerWithdrawalError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly details:
      | CustomerTurnoverDetails
      | Record<string, number | string | boolean>
      | null = null,
    public readonly statusCode = 0
  ) {
    super(message);
  }
}

function randomHex(size: number): string {
  const bytes = new Uint8Array(size);
  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(bytes);
    return Array.prototype.map
      .call(bytes, (byte: number) => byte.toString(16).padStart(2, "0"))
      .join("");
  }
  return Array.from({ length: size }, () =>
    Math.floor(Math.random() * 256)
      .toString(16)
      .padStart(2, "0")
  ).join("");
}

export function createWithdrawalRequestId(): string {
  return `withdraw_${Date.now()}_${randomHex(16)}`;
}

export async function submitCustomerWithdrawal(options: {
  accessToken: string;
  amount: number;
  requestId: string;
}): Promise<CustomerWithdrawalResponse> {
  try {
    const response = await axios.post(
      `${WITHDRAW_API_BASE}/customer/withdrawals`,
      {
        amount: options.amount,
        requestId: options.requestId
      },
      {
        headers: {
          Authorization: `Bearer ${options.accessToken}`
        },
        timeout: 20000
      }
    );
    return response.data as CustomerWithdrawalResponse;
  } catch (error) {
    const response = error && error.response;
    const payload = response && response.data ? response.data : {};
    throw new CustomerWithdrawalError(
      String(payload.code || "WITHDRAW_REQUEST_FAILED"),
      String(
        payload.message || "ระบบตรวจสอบสิทธิ์ถอนไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
      ),
      payload.details || null,
      Number(response && response.status) || 0
    );
  }
}
